import { z } from "zod";

export const rejectNegotiationSchema = z.object({
  observation: z.string({ message: 'Campo obrigatório' }),
});

export type RejectNegotiationValidationSchema = z.infer<typeof rejectNegotiationSchema>;
